import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { IDS } from '@/constants/testIds';

/**
 * Universal tour card.
 * props: tour, variant = 'default' | 'featured' | 'wide'
 */
export default function TourCard({ tour, variant = 'default', index = 0 }) {
  const isFestival = tour.category === 'festival';
  const discounted = isFestival ? Math.round(tour.price_usd * 0.95) : null;

  const aspect =
    variant === 'featured' ? 'aspect-[16/11] md:aspect-[16/9]' :
    variant === 'wide' ? 'aspect-[16/10] md:aspect-[16/8]' :
    'aspect-[4/5]';

  return (
    <motion.article
      data-testid={IDS.tourCard(tour.slug)}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1], delay: index * 0.05 }}
      className="group relative"
    >
      <Link to={`/tour/${tour.slug}`} data-testid={IDS.tourCardCta(tour.slug)} className="block">
        <div className={`relative overflow-hidden ${aspect} bg-secondary`}>
          <img
            src={tour.hero_image}
            alt={tour.title}
            className="absolute inset-0 w-full h-full object-cover zoom-img"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-espresso via-espresso/30 to-transparent" />

          {isFestival && (
            <div className="absolute top-4 left-4 bg-saffron text-foreground px-3 py-1.5 text-[10px] uppercase tracking-widest2 font-bold">
              −5% · Ранняя бронь
            </div>
          )}
          {tour.category === 'girls' && (
            <div className="absolute top-4 left-4 bg-crimson text-ivory px-3 py-1.5 text-[10px] uppercase tracking-widest2 font-bold">
              8 марта · только для неё
            </div>
          )}

          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
            <p className="overline text-foreground/70 mb-2">
              {tour.duration_days} дн. · {tour.cities.slice(0, 3).join(' · ')}
            </p>
            <h3 className="font-serif-display text-2xl md:text-3xl lg:text-4xl leading-[0.95] text-foreground mb-1.5">
              {tour.title}
            </h3>
            <p className="text-foreground/70 text-sm max-w-md leading-snug line-clamp-2">
              {tour.subtitle}
            </p>

            <div className="mt-4 flex items-end justify-between">
              <div>
                {discounted ? (
                  <div className="flex items-baseline gap-3">
                    <span className="font-serif-display text-2xl md:text-3xl text-saffron">${discounted}</span>
                    <span className="text-foreground/50 line-through text-sm">${tour.price_usd}</span>
                  </div>
                ) : (
                  <span className="font-serif-display text-2xl md:text-3xl text-foreground">${tour.price_usd}</span>
                )}
                <div className="text-[10px] uppercase tracking-widest2 text-foreground/50 mt-0.5">с человека</div>
              </div>
              <span className="text-[10px] uppercase tracking-widest2 font-bold text-saffron flex items-center gap-2">
                Подробнее
                <span className="w-6 h-px bg-saffron transition-all group-hover:w-12" />
              </span>
            </div>
          </div>
        </div>
      </Link>
    </motion.article>
  );
}
